import { WageAndTravelCategory } from '@nkr/enums/watr-category';
import { ICenterBase, IListItem } from '@nkr/models/index';
import { FormEvent, KeyboardEvent } from 'react';
import { FormControl, Button, FormGroup, ControlLabel, Well, Form, Row, Col } from 'react-bootstrap';
import { useMediaQuery } from 'react-responsive';

interface IProps {
    firstName: string,
    lastName: string,
    email: string,
    birthDate: string,
    alias: string,
    center: number,
    category: number,
    startDate: string,
    endDate: string,
    isAdmin: boolean,
    centerList: ICenterBase[],
    categoryList: IListItem[],
    onUpdate: (property: string, value: any) => void,
    onSearch: () => void,
    onReset: () => void
}

const SearchBar = (props: IProps) => {
    const isLessThan1920 = useMediaQuery({
        query: '(width < 1920px)'
    });

    const handleInputChange = (e: FormEvent<HTMLInputElement & HTMLSelectElement & FormControl>) => {
        let { name, value } = e.currentTarget;
        props.onUpdate(name, value);
    };

    const onKeyDown = (event: KeyboardEvent<any>) => {
        if (event.key === 'Enter') {
            props.onSearch();
        }
    };

    return (
        <Well bsSize="sm" style={{ marginBottom: 5 }}>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                {props.category != WageAndTravelCategory.PendSurgery && (
                    <>
                        <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%', alignItems: 'center' }}>
                            {props.isAdmin && (
                                <div style={{ marginRight: 20 }}>
                                    <div style={{ marginRight: 5 }}>Filter by Center</div>
                                    <div>
                                        <FormControl componentClass="select" name="center" value={props.center} onChange={handleInputChange}>
                                            <option value={0}>- All Centers -</option>
                                            {props.centerList.map((center) => (
                                                <option key={"ctr-" + center.id} value={center.id}>
                                                    {center.alias}
                                                </option>
                                            ))}
                                        </FormControl>
                                    </div>
                                </div>
                            )}

                            <div style={{ marginRight: 20 }}>
                                <div style={{ marginRight: 5 }}>Category</div>
                                <div>
                                    <FormControl componentClass="select" name="category" value={props.category} onChange={handleInputChange}>
                                        <option value={0}>- All Categories -</option>
                                        {props.categoryList.map((category) => (
                                            <option key={"cat-" + category.id} value={category.id}>
                                                {category.description}
                                            </option>
                                        ))}
                                    </FormControl>
                                </div>
                            </div>

                            <div style={{ marginRight: 20 }}>
                                <div style={{ marginRight: 5 }}>First Name</div>
                                <div>
                                    <FormControl name="firstName" value={props.firstName} onKeyDown={onKeyDown} onChange={handleInputChange} />
                                </div>
                            </div>

                            <div style={{ marginRight: 20 }}>
                                <div style={{ marginRight: 5 }}>Last Name</div>
                                <div>
                                    <FormControl name="lastName" value={props.lastName} onKeyDown={onKeyDown} onChange={handleInputChange} />
                                </div>
                            </div>

                            <div style={{ marginRight: 20 }}>
                                <div style={{ marginRight: 5 }}>Email:</div>
                                <div>
                                    <FormControl type="email" name="email" value={props.email} onKeyDown={onKeyDown} onChange={handleInputChange} />
                                </div>
                            </div>

                            <div style={{ marginRight: 20 }}>
                                <div style={{ marginRight: 5 }}>Birth Date:</div>
                                <div>
                                    <FormControl type="date" name="birthDate" value={props.birthDate} onKeyDown={onKeyDown} onChange={handleInputChange} />
                                </div>
                            </div>

                            <div style={{ marginRight: 20 }}>
                                <div style={{ marginRight: 5 }}>Alias:</div>
                                <div>
                                    <FormControl type="text" name="alias" value={props.alias} onKeyDown={onKeyDown} onChange={handleInputChange} />
                                </div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', width: '100%', marginTop: 10 }}>
                            <div style={{ marginRight: 20 }}>
                                <div style={{ marginRight: 5 }}>DS Reg Start Date</div>
                                <div>
                                    <FormControl type='date' name='startDate' value={props.startDate} onChange={handleInputChange} />
                                </div>
                            </div>

                            <div style={{ marginRight: 20 }}>
                                <div style={{ marginRight: 5 }}>DS Reg End Date</div>
                                <div>
                                    <FormControl type='date' name='endDate' value={props.endDate} onChange={handleInputChange} />
                                </div>
                            </div>

                            <div style={{ marginLeft: 50, marginTop: 19 }}>
                                <Button bsStyle="primary" onClick={props.onSearch}>Filter</Button>&nbsp;
                                <Button onClick={props.onReset}>Reset Filters</Button>
                            </div>
                        </div>
                    </>
                )}

                {props.category == WageAndTravelCategory.PendSurgery && props.isAdmin && (
                    <>
                        <div style={{ display: 'flex', width: '100%', marginTop: 10 }}>
                            <div style={{ marginRight: 20 }}>
                                <div style={{ marginRight: 5 }}>Surgery Start Date</div>
                                <div>
                                    <FormControl type='date' name='startDate' value={props.startDate} onChange={handleInputChange} />
                                </div>
                            </div>

                            <div style={{ marginRight: 20 }}>
                                <div style={{ marginRight: 5 }}>Surgery End Date</div>
                                <div>
                                    <FormControl type='date' name='endDate' value={props.endDate} onChange={handleInputChange} />
                                </div>
                            </div>

                            <div style={{ marginLeft: 50, marginTop: 19 }}>
                                <Button bsStyle="primary" onClick={props.onSearch}>Filter</Button>&nbsp;
                            </div>
                        </div>
                    </>
                )}

            </div>
        </Well>
    );
}

export default SearchBar;